module.exports = __webpack_public_path__ + "static/resources-bg-f4eb6d9d70ca7796bee0214dc597fcc5.jpg";